import { z } from "zod";
import { IsoDateTimeSchema } from "./primitives.js";
export const JobStatusSchema = z.enum(["queued", "running", "completed", "failed"]);
// POST /v1/export-jobs request — no fields required beyond the mutation
// envelope; export scope is always "everything this user owns" (GDPR).
export const ExportJobRequestSchema = z.object({}).strict();
export const ExportJobResponseSchema = z.object({
    id: z.string(),
    status: JobStatusSchema,
    downloadUrl: z.string().url().nullable(),
    expiresAt: IsoDateTimeSchema.nullable(),
    createdAt: IsoDateTimeSchema,
});
// POST /v1/deletion-jobs request — explicit re-confirmation, not implicit.
export const DeletionJobRequestSchema = z.object({
    confirmation: z.literal(true),
});
export const DeletionJobResponseSchema = z.object({
    id: z.string(),
    status: JobStatusSchema,
    createdAt: IsoDateTimeSchema,
});
//# sourceMappingURL=jobs.js.map